import { api } from './client';
export async function getCities() {
    return api('/api/cities');
}
